.backdrop {
  position: fixed;
  inset: 0;
  background: var(--color-overlay);
  transition: opacity var(--duration-slow) var(--easing-standard);
}

.backdrop[data-starting-style],
.backdrop[data-ending-style] {
  opacity: 0;
}

.panel {
  position: fixed;
  inset-block: 0;
  inset-inline-start: 0;
  display: flex;
  flex-direction: column;
  inline-size: min(85vw, calc(var(--sidebar-width) + var(--space-8)));
  border-inline-end: var(--border-width) solid var(--color-border);
  background: var(--color-surface);
  color: var(--color-text);
  box-shadow: var(--shadow-modal);
  outline: 0;
  transition: transform var(--duration-slow) var(--easing-standard);
}

.panel[data-size="md"] {
  inline-size: min(100vw, var(--dialog-md));
}

.panel[data-size="lg"] {
  inline-size: min(100vw, var(--dialog-lg));
}

.panel[data-side="end"] {
  inset-inline: auto 0;
  border-inline-start: var(--border-width) solid var(--color-border);
  border-inline-end: 0;
}

.panel[data-starting-style],
.panel[data-ending-style] {
  transform: translateX(-100%);
}

.panel[data-side="end"][data-starting-style],
.panel[data-side="end"][data-ending-style] {
  transform: translateX(100%);
}

@media (prefers-reduced-motion: reduce) {
  .panel {
    transition: opacity var(--duration-fast) ease;
  }

  .panel[data-starting-style],
  .panel[data-ending-style] {
    opacity: 0;
    transform: none;
  }
}

.header {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  justify-content: space-between;
  min-block-size: var(--header-height);
  padding-inline: var(--space-4) var(--space-2);
  border-block-end: var(--border-width) solid var(--color-border);
}

.header[data-hidden-title] {
  justify-content: flex-end;
}

.title {
  font-size: var(--text-lg);
  font-weight: var(--weight-semibold);
}

.hiddenTitle {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.body {
  flex: 1;
  min-block-size: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

/* Detail panels pad their content; the navigation lays out its own. */
.panel:is([data-size="md"], [data-size="lg"]) .body {
  padding: var(--space-4);
}
